<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
    [nzVisible]="isVisibleUserDrawer" [nzTitle]="userDrawerTitle" [nzFooter]="footerTpl" (nzOnCancel)="handleCancel()">
    <ng-container *nzModalContent>
        <div>
            <form nz-form [formGroup]="_fS.programForm">
                <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="labelError">
                                <label class="label-text required">Program label</label>
                                <input class="input-group" nz-input formControlName="label" minlength="2"
                                    maxlength="100" placeholder="Enter Program Label" />
                                <ng-template #labelError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please enter program
                                        label</ng-container>
                                    <ng-container *ngIf="control.hasError('minlength')">Program label name must contain
                                        at least 2
                                        characters
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="startMonthError">
                                <label class="label-text required">Program start</label>
                                <nz-select #proStartMonth nzShowSearch nzPlaceHolder="Month" [nzSize]="'default'"
                                    formControlName="startMonth" [nzSelectOnTab]="true"
                                    (ngModelChange)="focusProStartYear($event)">
                                    <nz-option *ngFor="let option of listOfMonths" [nzLabel]="option"
                                        [nzValue]="option"></nz-option>
                                </nz-select>
                                <ng-template #startMonthError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please select program start month
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="startYearError" class="mt-3">
                                <nz-select #proStartYear nzShowSearch nzPlaceHolder="Year" [nzSize]="'default'"
                                    [nzSelectOnTab]="true" formControlName="startYear"
                                    (ngModelChange)="onSelectStartYear($event)">
                                    <nz-option *ngFor="let option of listOfYears" [nzLabel]="option"
                                        [nzValue]="option"></nz-option>
                                </nz-select>
                                <ng-template #startYearError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please select program
                                        start year
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item>
                            <nz-form-control [nzErrorTip]="endMonthError">
                                <label class="label-text required">Program end</label>
                                <nz-select #proEndMonth nzShowSearch nzPlaceHolder="Month" [nzSize]="'default'"
                                    formControlName="endMonth" [nzSelectOnTab]="true"
                                    (ngModelChange)="focusProEndYear($event)">
                                    <nz-option *ngFor="let option of listOfMonths" [nzLabel]="option"
                                        [nzValue]="option"></nz-option>
                                </nz-select>
                                <ng-template #endMonthError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please select program end month
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item class="pt-27">
                            <nz-form-control [nzErrorTip]="endYearError">
                                <nz-select #proEndYear nzShowSearch nzPlaceHolder="Year" [nzSize]="'default'"
                                    formControlName="endYear" [nzSelectOnTab]="true">
                                    <nz-option *ngFor="let option of listOfEndYears" [nzLabel]="option"
                                        [nzValue]="option"></nz-option>
                                </nz-select>
                                <ng-template #endYearError let-control>
                                    <ng-container *ngIf="control.hasError('required')">Please select program end year
                                    </ng-container>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                        <nz-form-item class="margin-none">
                            <nz-form-control class="switch-box">
                                <nz-switch formControlName="isVisible"></nz-switch>
                                <label class="switch-label black mr-1">{{
                                    _fS.programForm.get("isVisible").value ? "Visible" : "Hidden"
                                    }}</label>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>
    <ng-template #footerTpl>
        <div class="d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100">Cancel</button>
            <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoadingUser"
                class="medium-btn small-btn width-100">{{
                selectedData != null ? 'Update' : 'Add' }}</button>
        </div>
    </ng-template>
</nz-modal>